var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.favorites,
      columns: _vm.columns_favorites,
      "row-key": "id",
      pagination: _vm.server_pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.server_pagination = $event
      },
      request: _vm.requestFavorites
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t(col.label)) + "\n        "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c("q-td", { key: "user_full_name", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.user_full_name) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "user_email", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.user_email) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "favorited_date", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.fDate(props.row.favorited_date)) +
                      "\n            "
                  )
                ])
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }